import { IBaseUse } from "@interfaces/Shared/baseUse";
import { IAwardVideo } from "@interfaces/awardVideo";
import getAwardVideo from "@services/Award/getAwardVideo";
import { useEffect, useState } from "react";

interface IUseAwardVideo extends IBaseUse {
  data: IAwardVideo | undefined;
  handleCallApi: () => void;
}

const useAwardVideo = (): IUseAwardVideo => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<IAwardVideo | undefined>(undefined);

  const handleCallApi = () => {
    setIsLoading(true);
    getAwardVideo()
      .then(async (response: { data: IAwardVideo }) => {
        setData(response.data);
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    handleCallApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    isLoading,
    handleCallApi,
  };
};

export default useAwardVideo;
